import { siteInfo } from '@/mocks/tanhua';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" 
        style={{
          backgroundImage: 'radial-gradient(circle at 25% 50%, oklch(var(--primary-500)) 0%, transparent 50%), radial-gradient(circle at 75% 30%, oklch(var(--accent-500)) 0%, transparent 40%)',
        }}
      />

      <div className="w-full px-4 md:px-6 lg:px-10 py-20 md:py-24 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span className="whitespace-nowrap">{siteInfo.tagline}</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight mb-4">
              {siteInfo.name}
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-500 mt-2">
                国产探花资源聚合平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 mb-5 font-heading">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {siteInfo.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {siteInfo.stats.map((stat, idx) => (
                <div key={idx} className="text-center">
                  <div className="text-xl md:text-2xl font-heading text-accent-500 whitespace-nowrap">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={siteInfo.primaryCta.href}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                {siteInfo.primaryCta.text}
              </a>
              <a
                href={siteInfo.secondaryCta.href}
                className="w-full sm:w-auto px-8 py-3.5 border border-foreground-300 text-foreground-700 font-medium rounded-md hover:bg-background-100 transition-colors text-center whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                {siteInfo.secondaryCta.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-500/10 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20atmospheric%20scene%20with%20elegant%20lighting%2C%20rich%20amber%20and%20crimson%20tones%2C%20professional%20studio%20photography%2C%20artistic%20composition%2C%20soft%20shadows%2C%20luxurious%20moody%20atmosphere%2C%20film%20noir%20aesthetic%2C%20abstract%20texture%20background&width=900&height=700&seq=tanhua-hero-visual&orientation=portrait"
                alt="探花系列 - 国产探花高清资源平台主视觉"
                className="relative w-full h-auto rounded-lg object-cover"
                style={{ aspectRatio: '900/700' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}